import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("MediaPublishOutput")
export class MediaPublishOutput {
    @JsonProperty("status", Boolean)
    public status: boolean = JsonPropertyEmpty;
}
